const playerName = {
  WebMediaPlayer: 'WebMediaPlayer',
  JPlayer: 'JPlayer',
  HlsJsPlayer: 'HlsJsPlayer',
  WindowsMediaPlayer: 'WindowsMediaPlayer',
  InstreamAdPlayer: 'InstreamAdPlayer',
  LiveSeekPlayer: 'LiveSeekPlayer',
};

export default playerName;
